import {
  Content,
  ContentHistory,
  ContentWorkflow,
  WorkflowEvent,
} from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { IMplServiceClient } from '../../api/IMplServiceClient';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import constants from '../../common/constants';
import AppContextProps from '../../contexts/AppContextProps';
import { ViewerType } from '../../model/Enum';
import Publication from '../../model/Publication';
import Breadcrumbs from '../common/Breadcrumbs';
import LoadingPage from '../common/LoadingPage';
import ReactRouterProps from '../utils/ReactRouterProps';
import DraftContentData from './content/DraftContentData';
import { APGLEntityEntry } from '@amzn/awscat-editor/dist/extensions/apgl-entity';
import { loadEntities } from '../utils/EntitiesUtils';
import { convertEntities } from '@amzn/awscat-editor';
import { withAppContext } from '../../contexts/AppContext';

interface Props extends AppContextProps, ReactRouterProps {
  location: any;
  match: any;
}

interface State {
  isLoading: boolean;
  content?: Content;
  workflow?: ContentWorkflow;
  workflowEvents?: WorkflowEvent[];
  workflowHistory?: ContentHistory[];
  entities: { [key: string]: APGLEntityEntry };
}

class ContentHistoryViewer extends React.Component<Props, State> {
  private readonly mplService: IMplServiceClient;

  // @ts-expect-error TS7006 - strict migration
  public constructor(props) {
    super(props);
    this.mplService = MplServiceClientFactory.create();

    this.state = {
      isLoading: true,
      entities: {},
    };
  }

  public async componentDidMount() {
    const { contentId, workflowId } = this.props.match.params;
    let historyResponse;
    try {
      historyResponse = await this.mplService.getPublicationByWorkflow(contentId, workflowId);
    } catch (e) {
      // @ts-expect-error TS18046 - strict migration
      if (e.response.status === 404) {
        historyResponse = new Publication();
      } else {
        throw e;
      }
    }

    const [eventsResponse, { workflows }] = await Promise.all([
      this.mplService.getContentEvents(contentId, workflowId),
      this.mplService.listWorkflowHistory(contentId),
    ]);

    const workflow = workflows.find(
      (wf) => wf.workflowId === parseInt(workflowId, constants.DECIMAL),
    );
    // Workaround to use ContentData component here as well. ContentHistory and Content Workflow should use common interface.
    const viewedWorkflow = Object.assign(new ContentWorkflow(), {
      ...workflow,
      // @ts-expect-error TS18048 - strict migration
      lastPublicationUpdate: workflow.lastUpdated,
    });

    const entities = await loadEntities();

    this.setState({
      content: historyResponse && historyResponse.content,
      isLoading: false,
      workflow: viewedWorkflow,
      workflowEvents: eventsResponse.events,
      workflowHistory: [],
      // @ts-expect-error TS2322 - strict migration
      entities,
    });
  }

  public render() {
    const { contentId, workflowId } = this.props.match.params;
    const { entities } = this.props.appContext;
    const { isLoading, content, workflow, workflowEvents } = this.state;

    if (isLoading) {
      return <LoadingPage />;
    }

    const breadcrumbItems = [
      {
        href: '/',
        text: constants.APP_NAME_BREAD_CRUMB,
      },
      {
        href: '',
        text: convertEntities(content?.contentMetadata.contentName ?? '', entities),
      },
    ];

    return (
      <div>
        <Breadcrumbs items={breadcrumbItems} />
        <DraftContentData
          contentId={contentId}
          workflowId={workflowId}
          content={content}
          isEditingAllowed={false}
          showContentControls={false}
          showReviewFeedback
          workflow={workflow}
          workflowEvents={workflowEvents}
          // @ts-expect-error TS18048 - strict migration
          contentAudience={workflow.contentAudience}
          viewerType={ViewerType.History}
          contentOwner={workflow?.ownerProfile}
          showTabView={false}
          entities={entities}
        />
      </div>
    );
  }
}

export default withAppContext(ContentHistoryViewer);
